module.exports = __webpack_public_path__ + "static/banner-mobile-empaques-7d2be0f094962be36acdafb00930b972.png";